/* =========================
   YOUR ORIGINAL CAROUSEL JS (UNCHANGED)
   ========================= */
(function(){
  const root = document.querySelector('[data-hx-ctgal]');
  if(!root) return;

  const track = root.querySelector('[data-hx-track]');
  const slides = Array.from(root.querySelectorAll('[data-hx-slide]'));
  const dots = Array.from(root.querySelectorAll('[data-hx-dot]'));
  const btnPrev = root.querySelector('[data-hx-prev]');
  const btnNext = root.querySelector('[data-hx-next]');

  if(!track || slides.length === 0) return;

  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  function activeIndexFromScroll(){
    const trackRect = track.getBoundingClientRect();
    const center = trackRect.left + trackRect.width / 2;

    let bestIdx = 0;
    let bestDist = Infinity;

    slides.forEach((slide, i) => {
      const r = slide.getBoundingClientRect();
      const c = r.left + r.width / 2;
      const d = Math.abs(c - center);
      if(d < bestDist){
        bestDist = d;
        bestIdx = i;
      }
    });

    return bestIdx;
  }

  function setActiveDot(i){
    dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
  }

  function scrollToIndex(i){
    const idx = clamp(i, 0, slides.length - 1);
    slides[idx].scrollIntoView({behavior:'smooth', inline:'center', block:'nearest'});
    setActiveDot(idx);
  }

  // Update dots on scroll (throttled via rAF)
  let ticking = false;
  track.addEventListener('scroll', () => {
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      setActiveDot(activeIndexFromScroll());
      ticking = false;
    });
  }, {passive:true});

  // Buttons
  if(btnPrev){
    btnPrev.addEventListener('click', () => {
      const idx = activeIndexFromScroll();
      scrollToIndex(idx - 1);
    });
  }
  if(btnNext){
    btnNext.addEventListener('click', () => {
      const idx = activeIndexFromScroll();
      scrollToIndex(idx + 1);
    });
  }

  // Dot click
  dots.forEach((dot, i) => {
    dot.style.cursor = 'pointer';
    dot.addEventListener('click', () => scrollToIndex(i));
  });

  // Ensure correct dot on load (after images/layout)
  window.requestAnimationFrame(() => setActiveDot(activeIndexFromScroll()));
})();


/* =========================
   ADD: SCROLL TRIGGER REVEAL (same as your other sections)
   ========================= */
(() => {
  const section = document.querySelector('.hx-ctgal.hx-scroll-trigger');
  if (!section) return;

  // explicit delays (kicker/title/sub/grid/note/fx wrapper)
  section.querySelectorAll('[data-hx-delay]').forEach(el => {
    el.style.transitionDelay = el.getAttribute('data-hx-delay') || '0ms';
  });

  // stagger tiles & swatches
  const base = 160;  // ms
  const step = 110;  // ms
  section.querySelectorAll('[data-hx-stagger]').forEach(el => {
    const i = parseInt(el.getAttribute('data-hx-stagger') || '0', 10);
    el.style.transitionDelay = (base + (i * step)) + 'ms';
  });

  const reveal = () => section.classList.add('hx-inview');

  if (!('IntersectionObserver' in window)) {
    reveal();
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        reveal();
        io.disconnect(); // once
      }
    });
  }, { threshold: 0.18 });

  io.observe(section);
})();
